module.exports = __webpack_public_path__ + "img/tickets-cart.82807a07.svg";